/**
 * SubListHeading: the heading that splits a record card into sub-lists
 * (the Care providers card's "Not in the Directory", "People" and
 * "Organizations"). A full-width sage band (sage-100) with forest text
 * (sage-800, 8.23:1), so it reads apart from the rows beneath it and
 * from the forest page band (SectionBand). An h4, labelled by its id.
 */

import { type ReactNode } from 'react';

export interface SubListHeadingProps {
  /** The heading's id: its section's aria-labelledby. */
  id: string;
  testId?: string;
  children: ReactNode;
}

export function SubListHeading({ id, testId, children }: SubListHeadingProps): ReactNode {
  return (
    <h4
      id={id}
      data-testid={testId}
      className="block w-full rounded-tight bg-sage-100 px-3 py-1.5 text-sm font-semibold text-sage-800"
    >
      {children}
    </h4>
  );
}
